export const PopoverInitializer = {
  init: () => {
    if (typeof window === 'undefined') {
      return
    }
    const doc = window.document
    const win = window as any
    setTimeout(() => {
      const popoverElements = doc.querySelectorAll('[data-toggle="popover"]')
      for (let i = 0; i < popoverElements.length; i++) {
        const tooltipElement = popoverElements[i]
        if (win.jQuery) {
          win.jQuery(tooltipElement).popover()
        }
      }
    }, 0)
  },
}
